import React from 'react';
import PropTypes from 'prop-types';
import { Form } from "../../collections/Form";
import { TextInput } from "../../inputs/TextInput";
import { EMAIL, FORGOT_PASSWORD, OWNER_LOGIN, PASSWORD, SEND_RESET, LOGIN } from "../../../utils/default-strings";
import { EMAIL_MAX_CHARACTERS, PASSWORD_MAX_CHARACTERS } from "./constants";
import { getForgotPasswordFormMarkup } from "./utils/getForgotPasswordFormMarkup";
export var Component = function Component(_ref) {
  var emailInputLabel = _ref.emailInputLabel,
      errorMessage = _ref.errorMessage,
      forgotPasswordEmailInputLabel = _ref.forgotPasswordEmailInputLabel,
      forgotPasswordErrorMessage = _ref.forgotPasswordErrorMessage,
      forgotPasswordHeadingText = _ref.forgotPasswordHeadingText,
      forgotPasswordModalTriggerText = _ref.forgotPasswordModalTriggerText,
      forgotPasswordSubmitButtonText = _ref.forgotPasswordSubmitButtonText,
      forgotPasswordSuccessMessage = _ref.forgotPasswordSuccessMessage,
      forgotPasswordValidation = _ref.forgotPasswordValidation,
      headingText = _ref.headingText,
      onForgotPasswordSubmit = _ref.onForgotPasswordSubmit,
      onSubmit = _ref.onSubmit,
      passwordInputLabel = _ref.passwordInputLabel,
      submitButtonText = _ref.submitButtonText,
      successMessage = _ref.successMessage,
      validation = _ref.validation;
  return React.createElement(Form, {
    actionLink: {
      text: getForgotPasswordFormMarkup(onForgotPasswordSubmit, forgotPasswordSubmitButtonText, forgotPasswordEmailInputLabel, forgotPasswordHeadingText, forgotPasswordModalTriggerText, forgotPasswordValidation, forgotPasswordErrorMessage, forgotPasswordSuccessMessage)
    },
    errorMessage: errorMessage,
    headingText: headingText,
    onSubmit: onSubmit,
    submitButtonText: submitButtonText,
    successMessage: successMessage,
    validation: validation
  }, React.createElement(TextInput, {
    autoComplete: "email",
    label: emailInputLabel,
    maxCharacters: EMAIL_MAX_CHARACTERS,
    name: "email"
  }), React.createElement(TextInput, {
    autoComplete: "current-password",
    label: passwordInputLabel,
    maxCharacters: PASSWORD_MAX_CHARACTERS,
    name: "password",
    type: "password"
  }));
};
Component.displayName = 'OwnerLogin';
Component.defaultProps = {
  emailInputLabel: EMAIL,
  errorMessage: '',
  forgotPasswordEmailInputLabel: EMAIL,
  forgotPasswordErrorMessage: '',
  forgotPasswordHeadingText: FORGOT_PASSWORD,
  forgotPasswordModalTriggerText: FORGOT_PASSWORD,
  forgotPasswordSubmitButtonText: SEND_RESET,
  forgotPasswordSuccessMessage: '',
  forgotPasswordValidation: {},
  headingText: OWNER_LOGIN,
  onForgotPasswordSubmit: Function.prototype,
  onSubmit: Function.prototype,
  passwordInputLabel: PASSWORD,
  submitButtonText: LOGIN,
  successMessage: '',
  validation: {}
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  emailInputLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  forgotPasswordEmailInputLabel: PropTypes.string,
  forgotPasswordErrorMessage: PropTypes.string,
  forgotPasswordHeadingText: PropTypes.string,
  forgotPasswordModalTriggerText: PropTypes.string,
  forgotPasswordSubmitButtonText: PropTypes.string,
  forgotPasswordSuccessMessage: PropTypes.string,
  forgotPasswordValidation: PropTypes.shape({
    email: PropTypes.object
  }),
  headingText: PropTypes.string,
  onForgotPasswordSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  passwordInputLabel: PropTypes.string,
  submitButtonText: PropTypes.string,
  successMessage: PropTypes.string,
  validation: PropTypes.shape({
    email: PropTypes.object,
    password: PropTypes.object
  })
} : {};